const localOverride = () => typeof window !== "undefined" &&
    window.localStorage.getItem("VITE_MESSAGING_ENABLED") === "1";
/** Mensajería activa para todos (sin flag local). */
export const MESSAGING_ENABLED = true;
export const isMessagingEnabled = () => localOverride() ||
    process.env.VUE_APP_MESSAGING_ENABLED === "true" ||
    MESSAGING_ENABLED;
export const MESSAGING_HTTP_BASE = process.env.VUE_APP_MESSAGING_HTTP_BASE ||
    "https://front.microcentrum.cl/v1/messaging";
